import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { KustoDataset } from 'app/model/dataset/kusto.dataset';
import { TabularCopySource, CopySourceMode } from './tabular-type.copysource';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'KustoSource',
    display: [
        format(stringResources.ModelName_CopySourceTemplate, stringResources.Kusto_DisplayText),
        format(stringResources.ModelName_CopySourcesTemplate, stringResources.Kusto_DisplayText)
    ],
    tags: { datasetModel: Metamodel.modelFor(KustoDataset) }
})
export class KustoCopySource extends TabularCopySource {
    public static readonly DATABASE: IAttribute;
    @Metamodel.attribute({
        templatable: true,
        association: 'DATABASE',
        display: stringResources.Database,
        constraint: {
            required: true
        }
    })
    public database?: string;
    // UI model only
    public mode: CopySourceMode = 'query'; // only support query
}
